import { render } from "./NftDetails.vue?vue&type=template&id=687e412c&scoped=true"
import script from "./NftDetails.vue?vue&type=script&lang=js"
export * from "./NftDetails.vue?vue&type=script&lang=js"

import "@/Common/Styles/nftDetails.scss?vue&type=style&index=0&id=687e412c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687e412c"]])

export default __exports__